<template>
    <div class="bubble-preview">
        <img
            @click="$bvModal.show('bubble-icon-modal')"
            v-if="getCustomBubbleIcon()"
            alt="bubble"
            :src="getCustomBubbleIcon()"
            :style="{ width, height }"
        />
        <div @click="$bvModal.show('bubble-icon-modal')" v-else>
            <Bubble1
                v-if="settings.bubble.preDefined === '1'"
                :style="{ width, height }"
                :color="settings.bubble.bubbleColor"
            />
            <Bubble2
                v-if="settings.bubble.preDefined === '2'"
                :style="{ width, height }"
                :color="settings.bubble.bubbleColor"
            />
            <Bubble3
                v-if="settings.bubble.preDefined === '3'"
                :style="{ width, height }"
                :color="settings.bubble.bubbleColor"
            />
            <Bubble4
                v-if="settings.bubble.preDefined === '4'"
                :style="{ width, height }"
                :color="settings.bubble.bubbleColor"
            />
            <Bubble5
                v-if="settings.bubble.preDefined === '5'"
                :style="{ width, height }"
                :color="settings.bubble.bubbleColor"
            />
            <Bubble6
                v-if="settings.bubble.preDefined === '6'"
                :style="{ width, height }"
                :color="settings.bubble.bubbleColor"
            />
            <Bubble7
                v-if="settings.bubble.preDefined === '7'"
                style="width: 155px; height: 50px; object-fit: contain"
                :color="settings.bubble.bubbleColor"
            />
            <Bubble8
                v-if="settings.bubble.preDefined === '8'"
                style="width: 155px; height: 50px; object-fit: contain"
                :color="settings.bubble.bubbleColor"
            />
        </div>
    </div>
</template>

<script>
import Bubble1 from "../svg/bubbles/Bubble1";
import Bubble2 from "../svg/bubbles/Bubble2";
import Bubble3 from "../svg/bubbles/Bubble3";
import Bubble4 from "../svg/bubbles/Bubble4";
import Bubble5 from "../svg/bubbles/Bubble5";
import Bubble6 from "../svg/bubbles/Bubble6";
import Bubble7 from "../svg/bubbles/Bubble7";
import Bubble8 from "../svg/bubbles/Bubble8";
import { mapActions, mapState } from "vuex";
import log2 from "../../utils/log2";

const log = log2("BubblePreview");
export default {
    name: "BubblePreview",
    components: {
        Bubble1,
        Bubble2,
        Bubble3,
        Bubble4,
        Bubble5,
        Bubble6,
        Bubble7,
        Bubble8,
    },
    props: {
        width: {
            type: String,
            default: "75px",
        },
        height: {
            type: String,
            default: "75px",
        },
    },
    data() {
        return {};
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            settingInitialized: (state) => state.setting.initialized,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        getCustomBubbleIcon() {
            const bubble = _.get(this.settings, "bubble");
            log("getCustomBubbleIcon bubble", _.cloneDeep(bubble));
            if (!!bubble) {
                const { preDefined } = bubble;
                log("getCustomBubbleIcon predefined", { preDefined, settings: { ...this.settings } });
                if (preDefined === "0") {
                    let { customIcon } = this.settings.bubble;
                    log("getCustomBubbleIcon customIcon", customIcon);
                    if (this.newIcon || customIcon) {
                        let { path, _id, ext } = this.newIcon || customIcon;
                        const url = `https://static.supsis.live/${path + _id}${ext ? "." + ext : ""}`;
                        log("getCustomBubbleIcon", url);
                        return url;
                    }
                }
            }

            return undefined;
        },
    },
};
</script>

<style scoped lang="scss">
.bubble-preview {
    object-fit: contain;
}
</style>
